"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.a = void 0;

function uuid() {
  var hashTable = ['a', 'b', 'c', 'd', 'e', 'f', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  var uuid = [];

  for (var i = 0; i < 35; i++) {
    if (i === 7 || i === 12 || i === 17 || i === 22) {
      uuid[i] = '-';
    } else {
      uuid[i] = hashTable[Math.floor(Math.random() * hashTable.length - 1)];
    }
  }

  return uuid.join('');
}

var uuid_1 = uuid;
exports.a = uuid_1;